import React, { useState } from "react";
import { IoClose, IoMenu } from "react-icons/io5";
import { MdContactPage, MdToken, MdPsychology } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Chat from "../../assets/images/icon/chat.png";
import User from "../../assets/images/icon/user.png";
import Setting from "../../assets/images/icon/gear.png";
import Upload from "../../assets/images/icon/Upload.png";
import UserIcon from "../../assets/images/icon/users.jpg";
import { useLang } from "../../context/LanguageContext";
import LogoutModal from "../LogoutModal";

const NAV_ITEMS_EN = [
  // { path: "/chat", icon: Chat, label: "CHAT IA" },
  // { path: "/document-upload", icon: Upload, label: "DOCUMENT UPLOAD" },
  { path: "/user-admin",   icon: User,          label: "USER ADMIN" },
  { path: "/ai-training",  icon: Setting,        label: "AI TRAINING" },
  { path: "/dashboard",    iconComponent: MdToken,       label: "TOKEN USAGE" },
  { path: "/contact-plan", iconComponent: MdContactPage, label: "CONTACT PLANS" },
  // { path: "/ai-rules",     iconComponent: MdPsychology,  label: "ORG AI RULES" },
];

const NAV_ITEMS_ES = [
  // { path: "/chat", icon: Chat, label: "CHAT IA" },
  // { path: "/document-upload", icon: Upload, label: "SUBE UN DOCUMENTO" },
  { path: "/user-admin",   icon: User,          label: "ADMINISTRADOR" },
  { path: "/ai-training",  icon: Setting,        label: "ENTRENAMIENTO IA" },
  { path: "/dashboard",    iconComponent: MdToken,       label: "USO DE TOKENS" },
  { path: "/contact-plan", iconComponent: MdContactPage, label: "PLANES CONTACTO" },
  // { path: "/ai-rules",     iconComponent: MdPsychology,  label: "REGLAS IA ORG" },
];

const MobileSidebar = () => {
  const path = window.location.pathname;
  const navigate = useNavigate();
  const { lang, handleLangToggle } = useLang();
  const [isOpen, setIsOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [imagePreview] = useState(() => {
    const img = localStorage.getItem("groupImage");
    return img && img !== "undefined" ? img : null;
  });
  const [username] = useState(localStorage.getItem("username") || "ADMIN");
  const [groupname] = useState(localStorage.getItem("groupname") || "ORG / COMPANY");

  const toggleOffCanvas = () => {
    setIsOpen((v) => !v);
    document.body.style.overflow = isOpen ? "auto" : "hidden";
  };

  const handleNavigate = (navPath) => {
    navigate(navPath);
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const handleLogOutConfirm = () => {
    setIsLogoutModalOpen(false);
    setIsOpen(false);
    document.body.style.overflow = "auto";
    localStorage.clear();
    navigate("/login");
  };

  const navItems = lang === "EN" ? NAV_ITEMS_EN : NAV_ITEMS_ES;

  return (
    <div className="md:hidden">
      {/* Toggle Button */}
      <button
        onClick={toggleOffCanvas}
        className="z-50 p-2 rounded-lg bg-white/20 text-white transition-colors relative"
        aria-label="Toggle off-canvas menu"
      >
        {isOpen ? (
          <IoClose className="text-xl" />
        ) : (
          <IoMenu className="text-xl" />
        )}
      </button>

      {/* Overlay */}
      <div
        onClick={toggleOffCanvas}
        className={`fixed inset-0 bg-black transition-opacity duration-300 ease-in-out z-40
        ${isOpen ? "opacity-50 visible" : "opacity-0 invisible"}`}
      />

      {/* Off-canvas Panel — full screen on mobile, 280px on sm+ */}
      <div
        className={`fixed top-0 left-0 h-screen flex flex-col z-50 overflow-y-auto w-screen sm:w-[280px] shadow-2xl transform transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
        style={{ background: "linear-gradient(180deg, #1A0E3E 0%, #4F2A71 60%, #904DB0 100%)" }}
      >
        {/* Close button — mobile full-screen only */}
        <button
          onClick={toggleOffCanvas}
          className="sm:hidden absolute top-4 right-4 text-[#C7BFE5] hover:text-white z-10"
          aria-label="Close menu"
        >
          <IoClose className="text-2xl" />
        </button>

        <div className="flex flex-col justify-between min-h-screen w-full pt-8 pb-8">
          <div className="w-full flex flex-col items-center gap-4">
            {/* ENG / ESP toggle */}
            <div
              className="flex items-center rounded-full overflow-hidden"
              style={{ width: "144.93px", height: "32px", border: "3px solid #C7BFE5" }}
            >
              <button
                onClick={() => handleLangToggle("EN")}
                className="flex-1 h-full flex items-center justify-center font-roboto font-extrabold text-[11px] uppercase leading-none transition-all"
                style={{
                  color: lang === "EN" ? "#1A0E3E" : "#C7BFE5",
                  background: lang === "EN" ? "#C7BFE5" : "transparent",
                  borderRadius: lang === "EN" ? "9999px" : "0",
                }}
              >
                ENG
              </button>
              <button
                onClick={() => handleLangToggle("ES")}
                className="flex-1 h-full flex items-center justify-center font-roboto font-extrabold text-[11px] uppercase leading-none transition-all"
                style={{
                  color: lang === "ES" ? "#1A0E3E" : "#C7BFE5",
                  background: lang === "ES" ? "#C7BFE5" : "transparent",
                  borderRadius: lang === "ES" ? "9999px" : "0",
                }}
              >
                ESP
              </button>
            </div>

            {/* Profile circle */}
            <div
              className="rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden mt-16"
              style={{
                width: "133.21px",
                height: "133.21px",
                background: "linear-gradient(to bottom, #904DB0, #C7BFE5)",
              }}
            >
              {imagePreview ? (
                <img src={imagePreview} alt="Preview" className="w-full h-full object-cover rounded-full" />
              ) : (
                <img src={UserIcon} alt="user" className="w-full h-full object-cover rounded-full" />
              )}
            </div>

            {/* Username */}
            <p
              className="font-roboto font-bold uppercase text-center leading-none mt-8"
              style={{ fontSize: "20px", color: "#904DB0" }}
            >
              {username}
            </p>

            {/* Org / Company */}
            {/* <p
              className="font-roboto font-bold uppercase text-center leading-none text-white"
              style={{ fontSize: "18px", marginTop: "19px" }}
            >
              {groupname}
            </p> */}

            {/* Nav items */}
            <div className="grid gap-2 w-full mt-4 px-3">
              {navItems.map((item) => {
                const isActive = path.includes(item.path);
                return (
                  <button
                    key={item.path}
                    onClick={() => handleNavigate(item.path)}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-roboto font-semibold text-sm text-white transition-all ${isActive
                        ? "bg-white/20 border border-white/40"
                        : "bg-transparent border border-transparent hover:bg-white/10"
                      }`}
                  >
                    {item.iconComponent
                      ? <item.iconComponent className="h-5 w-5 flex-shrink-0 text-white" />
                      : <img src={item.icon} alt={item.label} className="h-5 w-5 object-contain flex-shrink-0 brightness-0 invert" />
                    }
                    {item.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Bottom buttons */}
          <div className="w-full flex flex-col items-center gap-2 px-3">
            <button
              onClick={() => setIsLogoutModalOpen(true)}
              className="font-roboto font-bold text-[18px] uppercase text-[#1A0E3E] leading-none rounded-[6px] bg-[#C7BFE5] hover:bg-[#b5acd6] transition-all cursor-pointer"
              style={{ width: "217.84px", height: "37.39px" }}
            >
              {lang === "EN" ? "LOG OUT" : "CERRAR SESIÓN"}
            </button>
          </div>

          {/* Logout Confirmation Modal */}
          <LogoutModal
            isOpen={isLogoutModalOpen}
            onClose={() => setIsLogoutModalOpen(false)}
            onConfirm={handleLogOutConfirm}
            lang={lang}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileSidebar;
